<template lang="pug">
.hour
  .row.details
    .col-xs-12
      .rounded-checkbox-wrapper.checkbox-md.select-row-wrapper
        input.rounded-checkbox(
          v-model="selected"
          :class="{ 'not-clickable': allView || !canSelectAny }"
          :disabled="!canSelectAny"
          type="checkbox"
        )
        label
      .action-hover
        .hour-range.inline-block {{ hourRange }}
        span Total time worked:
        = " "
        span.hourly_total {{ $filters.formatDuration(hour.tracked) }}
  .row.row-activity
    .col-xs-12
      .row(v-if="blockView")
        .col-lg-2.col-md-3.col-sm-4.col-xs-6.margin-bottom-xs(
          v-for="(activity, index) in hour.activities"
          :key="index"
        )
          ActivitiesBlock(
            :activity="activity"
            :observer="observer"
            :view-only="viewOnly"
          )
      .row(v-else-if="allView")
        template(v-if="screenshots.length > 0")
          template(v-for="activity in validActivities")
            .col-lg-2.col-md-4.col-sm-4.col-xs-6.margin-bottom-xs(
              v-for="(screen, index) in activity.screens"
              :key="index"
            )
              ActivitiesScreenshot(
                :observer="observer"
                :activity="activity"
                :screenshot="screen"
              )
        .col-lg-2.col-md-4.col-sm-4.col-xs-6.margin-bottom-xs.no-screenshots-block(v-else)
          ActivitiesScreenshot(:observer="observer")
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { formatDatetimeRange, parseInternalDatetime } from '~/utils/time_utils';
import ActivitiesBlock from './ActivitiesBlock.vue';
import ActivitiesScreenshot from './ActivitiesScreenshot.vue';

export default {
  name: 'ActivitiesHourRow',
  components: {
    ActivitiesBlock,
    ActivitiesScreenshot,
  },
  props: {
    hour: {
      type: Object,
      required: true,
    },
    observer: {
      type: IntersectionObserver,
      required: true,
    },
  },
  computed: {
    ...mapState({
      selectedTimeSlots: (state) => state.selected_time_slots.map((ts) => ts.timeSlot),
      viewOnly: (state) => state.view_only,
    }),
    ...mapGetters(['allView', 'blockView', 'hasData', 'queryDate']),
    hourRange() {
      const start = parseInternalDatetime(this.hour.starts_at);
      const stop = moment(start).add(1, 'hour');

      return formatDatetimeRange(start, stop, { style: 'time' });
    },
    screenshots() {
      return this.validActivities.flatMap((activities) => activities.screens || []);
    },
    validActivities() {
      return this.hour.activities.filter((activity) => activity);
    },
    selectableActivities() {
      return this.validActivities.filter((activity) => {
        const permissions = activity.permissions || {};
        const canChangeActivityDelete = Boolean(permissions.can_change_activity_delete);
        const canChangeActivityModify = Boolean(permissions.can_change_activity_modify);
        const canOverrideLocked = Boolean(activity.overrideable);
        const locked = Boolean(activity.locked);

        return (
          (canChangeActivityDelete || canChangeActivityModify || (locked && canOverrideLocked)) &&
          (!locked || canOverrideLocked)
        );
      });
    },
    selectableTimeSlots() {
      return this.selectableActivities.map((activity) => ({
        timeSlot: activity.time_slot,
        screens: activity.screens,
        tracked: activity.tracked,
        projects: activity.project_names,
      }));
    },
    canSelectAny() {
      return this.selectableTimeSlots.length > 0;
    },
    allSelected() {
      if (!this.canSelectAny) {
        return false;
      }

      return !this.selectableTimeSlots.some((timeSlot) => !this.selectedTimeSlots.includes(timeSlot.timeSlot));
    },
    selected: {
      get() {
        return this.allSelected;
      },
      set() {
        if (!this.canSelectAny) {
          return;
        }

        if (this.allSelected) {
          this.deselectTimeSlots(this.selectableTimeSlots.map((ts) => ts.timeSlot));
        } else {
          this.selectTimeSlots(this.selectableTimeSlots);
        }
      },
    },
  },
  methods: {
    ...mapActions(['selectTimeSlots', 'deselectTimeSlots']),
  },
};
</script>
